import { createRouter, createWebHashHistory } from 'vue-router'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      component: () => import('@/views/home.vue'),
    },
    {
      path: '/car-detail',
      component: () => import('@/views/cardetail/index.vue'),
      name: 'car-detail'
    },
    {
      path: '/garage',
      component: () => import('@/views/garage/index.vue'),
      name: 'garage',
      meta: {
        title: 'garage',
        pageName: 'garage',
      }
    },
    {
      path: '/vehiceltype',
      component: () => import('@/views/garage/vehicleType/index.vue'),
      name: 'vehiceltype',
      meta: {
        title: 'vehiceltype',
        pageName: 'vehicle_type',
      }
    },
    {
      path: '/selectVehicleInfo',
      component: () => import('@/views/garage/selectVehicleInfo/index.vue'),
      name: 'selectVehicleInfo',
      meta: {
        title: 'selectVehicleInfo',
        pageName: 'select_vehicle_info',
      }
    },
    {
      path: '/confirmVehicle',
      component: () => import('@/views/garage/confirmVehicle/index.vue'),
      name: 'confirmVehicle',
      meta: {
        title: 'confirmVehicle',
        pageName: 'confirm_vehicle',
      }
    },
    {
      path: '/deleteVehicle',
      component: () => import('@/views/garage/deleteVehicle/index.vue'),
      name: 'deleteVehicle',
      meta: {
        title: 'deleteVehicle',
        pageName: 'delete_vehicle',
      }
    },
    {
      path: '/selectGarageVehicle',
      component: () => import('@/views/garage/selectGarageVehicle/index.vue'),
      name: 'selectGarageVehicle',
      meta: {
        title: 'selectGarageVehicle',
        pageName: 'select_garage_vehicle'
      }
    }
  ]
})

export default router
